module.exports = __webpack_public_path__ + "static/media/copysmith-workflow-large.c10ea654.png";